module.exports = __webpack_public_path__ + "ada6ec79ad485b83f64c84bb51adf8a0.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/next.svg
// module id = 1356
// module chunks = 74